import React from 'react';
import { Skeleton } from 'antd';

/**
 * 通用页面骨架屏
 * 支持 loading 属性控制显示/隐藏，适配明暗双模式
 */
class SkeletonPage extends React.Component {
  render() {
    const { loading, children, rows = 6, active = true } = this.props;

    if (!loading) {
      return children || null;
    }

    const loadingTexts = [
      '正在整理时间数据...',
      '正在计算收支明细...',
      '正在分析写作记录...',
      '正在生成分析报告...',
      '正在加载您的数据...',
    ];
    const randomText = loadingTexts[Math.floor(Math.random() * loadingTexts.length)];

    return (
      <div className="sj-skeleton-page" style={{ padding: '40px 20px', textAlign: 'center' }}>
        <Skeleton active={active} title paragraph={{ rows }} />
        <div style={{ marginTop: 24, color: 'var(--sj-text-secondary)', fontSize: 14 }}>
          {randomText}
        </div>
      </div>
    );
  }
}

export default SkeletonPage;
